import {
  Event,
  Participant,
  SubParticipantPosition,
  type SubParticipantFlag,
} from '@collector/sportsapi-client-legacy'

import { HttpClient } from '../../httpClient.js'

export type SubParticipantsSavePostSquad = {
  player_position?: number
  position?: SubParticipantPosition
  position_reason_code?: string
  position_reason_id?: number
  position_detailed_reason_id?: number
  captain?: boolean
  id?: number | null
  shirt_nr?: string | number
  short_name?: string
  flags?: SubParticipantFlag[]
}

/**
 * Endpoint for replacing the whole squad (subparticipants for participant in event) in single request.
 */
export async function post(
  httpClient: HttpClient,
  eventId: Event['id'],
  participantId: Participant['id'],
  squad: SubParticipantsSavePostSquad[],
): Promise<unknown> {
  return httpClient
    .url(`/events/${eventId}/sub-participants-save`)
    .post({ team_id: participantId, squad })
    .json()
}
